export const Locale = {
  EN: 'en',
  ZH: 'zh',
  ES: 'es',
  JA: 'ja'
} as const;
export type LocaleValue = (typeof Locale)[keyof typeof Locale];
export type LocaleKey = keyof typeof Locale;
